<template>
  <div
    class="zm-upload-dragger"
    :class="{
      'is-dragover': dragover
    }"
    @drop.prevent="onDrop"
    @dragover.prevent="onDragover"
    @dragleave.prevent="dragover = false"
  >
    <slot></slot>
  </div>
</template>
<script>
  export default {
    name: 'ZmUploadDrag',
    props: {
      disabled: Boolean
    },
    inject: {
      uploader: {
        default: ''
      }
    },
    data() {
      return {
        dragover: false
      };
    },
    methods: {
      onDragover() {
        if (!this.disabled) {
          this.dragover = true;
        }
      },
      onDrop(e) {
        if (this.disabled || !this.uploader) return;
        const accept = this.uploader.accept;
        this.dragover = false;
        if (!accept) {
          this.$emit('file', e.dataTransfer.files);
          return;
        }
        this.$emit('file', [].slice.call(e.dataTransfer.files).filter(file => {
          const { type, name } = file;
          const extension = name.indexOf('.') > -1
            ? `.${ name.split('.').pop() }`
            : '';
          const baseType = type.replace(/\/.*$/, '');
          return accept.split(',')
            .map(type => type.trim())
            .filter(type => type)
            .some(acceptedType => {
              if (/\..+$/.test(acceptedType)) {
                return extension === acceptedType;
              }
              if (/\/\*$/.test(acceptedType)) {
                return baseType === acceptedType.replace(/\/\*$/, '');
              }
              if (/^[^\/]+\/[^\/]+$/.test(acceptedType)) {
                return type === acceptedType;
              }
              return false;
            });
        }));
      }
    }
  };
</script>

<style lang="scss">
  @import "../../scss/mixins/mixins";
  @import "../../scss/common/var";

  @include b(upload-dragger) {
    background-color: #fff;
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    box-sizing: border-box;
    width: 360px;
    height: 180px;
    text-align: center;
    cursor: pointer;
    position: relative;
    overflow: hidden;

    .zm-icon-upload {
      font-size: 67px;
      color: $--color-text-placeholder;
      margin: 40px 0 16px;
      line-height: 50px;
    }

    + .zm-upload__tip {
      text-align: center;
    }

    ~ .zm-upload__files {
      border-top: $--border-base;
      margin-top: 7px;
      padding-top: 5px;
    }

    .zm-upload__text {
      color: $--color-text-primary;
      font-size: 14px;
      text-align: center;

      em {
        color: $--color-primary;
        font-style: normal;
      }
    }

    &:hover {
      border-color: $--color-primary;
    }

    @include when(dragover) {
      background-color: rgba(32, 159, 255, .06);
      outline: 2px dashed $--color-primary;
    }
  }
  .zm-theme--dark {
    @include b(upload-dragger){
      background-color: #131619;
      color: #fff;
      .zm-upload__text{
        color: #fff;
      }
    }
  }
</style>

